module.exports = __webpack_public_path__ + "img/man_handup.63f87724.svg";